"use client"

import styled from "@emotion/styled"
import { useInView } from "react-intersection-observer"
import colors from "theme/colors"
import { Container, NewText, useInViewConfig, useTransitionUpStyles } from "ui"
import { delayTime, styleObjectToCss } from "ui/transitions/utils"
import { extractProperty } from "utils"

const StyledContainer = styled.div`
  margin-top: 32px;
  margin-bottom: 24px;

  ${(props) => props.theme.breakpoints.up("md")} {
    margin-top: 64px;
    margin-bottom: 80px;
  }
`
type Props = {
  data: any
}

function Header({ data }: Props) {
  const mainTitle = extractProperty(data, "mainTitle")
  const subTitle = extractProperty(data, "subTitle")
  const { ref, inView } = useInView(useInViewConfig)

  const imageTransitionStyles = useTransitionUpStyles(inView)
  const descriptionTransitionStyles = useTransitionUpStyles(inView, delayTime)

  return (
    <Container>
      <StyledContainer ref={ref}>
        <NewText
          cssString={styleObjectToCss(imageTransitionStyles)}
          component={"h1"}
          desktopFontSize={48}
          desktopLineHeight={"69px"}
          desktopFontWeight={600}
          mobileFontSize={40}
          mobileLineHeight={"46px"}
          color={colors.black}
        >
          {mainTitle}
        </NewText>
        <NewText
          cssString={styleObjectToCss(descriptionTransitionStyles)}
          component={"p"}
          desktopFontSize={16}
          desktopLineHeight={"23px"}
          desktopFontWeight={400}
          mobileFontSize={20}
          mobileLineHeight={"29px"}
          color={colors.black}
          marginTop={"16px"}
        >
          {subTitle}
        </NewText>
      </StyledContainer>
    </Container>
  )
}

export default Header
